export default {
    global: {
        alert: {
            session_expired_title: `您的会话已过期`,
            session_expired_subtitle: `抱歉，您的会话已过期, 请重新登陆。`,
            staging_alert_msg: `警告`,
            staging_alert_desc: `请注意, 您正在使用的是测试环境。请不要进行任何存取以及买卖操作以避免不必要的损失.`,
        },
        menu: {
            home: "主页",
            features: "特点",
            privacy: "隐私政策",
            term_of_use: "使用条款",
            buy_sell: "买/卖",
            contact_us: "联系我们",
            faq: "常见问题",
            dashboard: "交易面板",
            my_profile: "我的信息",
            deposits: "存款",
            withdrawals: "提款",
            referral: "推荐",
            history: "历史",
            security: "安全",
            support: "支持",
            complete_kyc: "完成 KYC",
            make_withdrawals: "发起提款",
            manage_crypto_addresses: "管理加密货币地址",
            manage_bank_accounts: "管理银行账户",
            update_password: "修改密码",
            update_2fa: "修改 2FA",
            developer_api: "开发者 API",
            merchant_sub_accounts: "商户子账户",
            warning_id_not_verified: "身份尚未验证!",
            btn_sign_up: "注册",
            btn_sign_in: "登录",
            btn_sign_off: "注销",
            confirm_logout_title: "确定要退出登录吗？",
            confirm_ok: "确定",
            confirm_cancel: "取消",
        },
        risk_banner: {
            headline: `风险提醒：`,
            description_before_not: `OTCPro 是一家独立注册于 AUSTRAC 的加密货币交易所，`,
            description_not: `不会`,
            description_after_not: ` 与任何第三方、代理、投资计划或资产追回服务合作。切勿向任何在官方渠道之外声称代表 OTCPro 的人转账。`,
            contact_us: `联系我们`,
            close: `关闭风险提醒`,
        },
        deposit_pending_banner: {
            description_before: `您的充值处于`,
            status: `待处理`,
            description_after: `状态，请补充发送方信息以确保及时处理。只需一分钟。`,
            cta: `立即处理`,
        }
    },
    home: {
        banner: {
            introducing: `欢迎使用`,
            title: `电子报价平台`,
            desc: `让您的虚拟货币交易变得更简单, 更智慧`,
            signup: `立即注册`
        },
        price: {
            title: `您可以与我们交易的货币`,
            desc: `我们会加入更多的货币, 同时也请告诉我们您希望交易的货币!`,
            buy_price: `买入价`,
            sell_price: `卖出价`,
            aud: `澳元`,
            usd: `美元`,
            others: `其他`,
        },
        feature: {
            title: `主要特点`,
            desc: `我们为何与众不同`,
            steaming_price: `实时价格`,
            steaming_price_desc: `定量监控实时价格 点击完成交易。`,
            no_fee: `无交易费`,
            no_fee_desc: `交易费已是过去, 不必再计算, 所见即所得。`,
            deep_liquidity: `深度流动性`,
            deep_liquidity_desc: `执行大额交易而不必过多切换市场。`,
            compliant: `符合规范`,
            compliant_desc: `我们是澳大利亚交易报告和分析中心注册平台。以全面合规程序确保您的资金始终安全可靠。`,
            future_Release: `即将推出`,
            lock_price: `先锁定价格 24小时内完成交易。`,
            set_limit: `设定限价订单 已待更好的价格。`,
        },
        who_we_are: {
            title: `关于我们`,
            sub_title: `专家团队`,
            dsec: `我们是一个拥有超过5年加密程序交易经验的团队，成功地为主流交易所提供了流动性。现在我们将流动价格带到场外交易市场，帮助您一键管理您的交易。`
        },
        faqs: {
            title: `常见问题`,
            what_is_otcpro: {
                title: `什么是OTCPro`,
                desc: `OTCPro是一个流动性定价的加密货币场外交易平台，允许买家和卖家在指定数量获得实时报价，并一键执行。`
            },
            deposits: {
                title: `存款`,
                crypto_deposits: {
                    title: `加密货币存款`,
                    desc: `OTCPro的每位客户都会获得一个独特的钱包地址来接收加密货币。您可以在仪表板屏幕上点击‘存款’，然后选择您希望存入的货币来找到您的钱包地址。`
                },
                deposit_not_arrived: {
                    title: `存款未到账`,
                    desc: `首先，请确保您发送到正确的钱包地址，然后使用您的交易哈希在区块链上检查交易状态，不同的资产需要不同的确认次数才能完全确认并记入您的帐户。如果您对存款仍有疑问，请联系客户支持。`
                },
                fiat_deposits: {
                    title: `法币存款`,
                    desc: `OTCPro鼓励澳大利亚本地客户使用PayID方法存入澳元。通过PayID存款是免费且快速的。如果您不在澳大利亚或无法使用PayID，我们还提供BSB和帐号来接收法币存款。无论您选择哪种方法，请确保您的银行帐户与OTCPro注册的名称匹配。任何第三方存款都将被保留并标记您的帐户以供审核。`
                },
                how_long_does_it_take: {
                    title: `需要多长时间`,
                    desc: `PayID存款通常是即时的，但首次存款可能需要长达24小时。银行转账通常需要1-3个工作日。`
                },
            },
            withdrawals: {
                title: `提款`,
                how_long_does_it_take: {
                    title: `需要多长时间`,
                    desc: `您的法币和加密货币提款通常会在48小时内处理，但由于服务提供商和银行中断可能会有延迟。`
                },
                withdrawal_limit: {
                    title: `提款限额`,
                    desc: `您可以在仪表板上查看您的每日提款限额。每个用户起初都会获得100,000美元的每日提款限额，这个限额是法币和加密货币共享的。您可以提交请求给我们的支持团队来增加限额，您的请求将根据您的交易量、风险等级等进行审查。`
                },
            },
            trading: {
                title: `交易`,
                desc: `我们的流动性定价交易系统允许用户监控用户定义的数量的实时价格，并一键执行。只需输入您想要的加密货币数量，报价将相应地调整，选择您的交易方向（买/卖），然后交易。`,
                secure_price_inadvance: {
                    title: `预先确定价格`,
                    desc: `此功能允许用户在没有交易的全部价值的情况下进行交易。为了预先确定交易的价格，您需要：`,
                    sub_1: `在您的帐户中持有一定的余额，无论是法币还是数字货币，至少是我们根据您的风险级别设定的预定金额`,
                    sub_2: `在放置交易后的24小时内结算您的交易。延迟结算将产生0.1%的每日费用，超过未付金额。`,
                    paragraph: `您可以向我们的客户支持发送请求以启用此功能。我们需要评估您的财务状况、交易记录和风险级别来决定对您的帐户的风险敞口限制（您用于交易的最大透支金额）。同时，您需要维持最低保证金要求（当进行“预先确定价格”的交易时，您需要在帐户中保留的存款）。`
                },
            },
            referral: {
                title: `推荐`,
                desc: `邀请您的朋友并获得他们交易量的0.05%佣金。推荐佣金在每月底计算并释放到您的帐户。它将直接记入您的澳元余额。`
            },
            fees: {
                title: `费用`,
                list_1: `交易：没有交易费或交换费`,
                list_2: `存款：平台的存款没有收费，无论是法币还是加密货币。我们会将我们这边收到的确切金额反映到您的平台账户`,
                list_3: `提款：澳大利亚本地的澳元提款没有费用，但在异常情况下可能会产生一些费用，包括：
                被拒绝的法币提款：每笔本地交易5.00美元，资金退回后将从您的OTCPro帐户余额中扣除
                国际法币提款：30.00 - 50.00美元的转账费，取决于货币和支付服务提供商的收费。这将从您的提款金额中扣除。`,
                list_4: `迟延结算费：在“预先确定价格”模式下，如果交易在24小时内未结算，将对未付款项收取0.1%的每日利率。`,
                list_5: `由用户引起的任何额外费用都将由客户承担。`,
            },
            account_security: {
                title: `账户安全`,
                desc: `OTCPro使用Google Authenticator应用程序提供双因素身份验证。双因素身份验证是从您的Google Authenticator移动应用程序生成的一次性代码，为您的账户提供额外的安全层。我们强烈建议我们的客户启用2FA来保护您的账户的安全。`
            },
            prohibited_jurisdictions: {
                title: `禁止的司法管辖区`,
                desc: `我们不会为以下司法管辖区的客户提供我们的服务：`,
                list_1: `美国；`,
                list_2: `高风险司法管辖区，包括以下国家：
                阿富汗、博茨瓦纳、布隆迪、喀麦隆、乍得、刚果民主共和国、科特迪瓦、古巴、厄立特里亚、冈比亚、加纳、几内亚、海地、伊朗、伊拉克、朝鲜、吉尔吉斯斯坦、黎巴嫩、莱索托、利比里亚、利比亚、马里、缅甸、尼日尔、索马里、苏丹、叙利亚、乌干达、也门、津巴布韦`,
                list_3: `中风险司法管辖区，包括以下国家：
                安哥拉、孟加拉国、巴林、白俄罗斯、玻利维亚、布基纳法索、柬埔寨、中国、中非共和国、哥伦比亚、科摩罗、厄瓜多尔、埃及、赤道几内亚、埃塞俄比亚、格鲁吉亚、格陵兰、危地马拉、几内亚比绍、梵蒂冈、印度、印度尼西亚、以色列、乔丹、哈萨克斯坦、肯尼亚、科威特、老挝、马达加斯加、马拉维、毛里塔尼亚、尼日利亚、阿曼、巴基斯坦、巴勒斯坦、巴布亚新几内亚、秘鲁、菲律宾、俄罗斯、卡塔尔、卢旺达、圣多美和普林西比、沙特阿拉伯、塞拉利昂、所罗门群岛、斯里兰卡、南非、塔吉克斯坦、东帝汶、多哥、土耳其、土库曼斯坦、阿拉伯联合酋长国、乌兹别克斯坦、委内瑞拉、越南、赞比亚`            
            },
        },
        get_in_touch: {
            title: `联系我们`,
            sub_title_1: `常规查询`,
            sub_title_2: `提交请求`,
            name: `姓名`,
            email: `电子邮件`,
            message: `留言`,
            btn: `发送`
        },
        ribbon: {
            title: `今天就开始交易吧！`,
            btn: `点击注册`
        },
    },
    contact_us: {
        title: `联系支持`,
        subtitle_1: `我们的支持团队周一至周五 9:00am – 5:30pm AET 在线服务。`,
        subtitle_2: `我们会尽快回复您的咨询。`,
        name: `姓名`,
        email: `注册邮箱`,
        guest_email: `邮箱`,
        topic: `主题`,
        message: `留言`,
        name_placeholder: `姓名`,
        email_placeholder: `邮箱`,
        topic_placeholder: `请选择咨询原因`,
        message_placeholder: `请描述您的问题，如有交易 ID、钱包地址或截图请一并提供。`,
        name_required: `请填写姓名。`,
        email_invalid: `邮箱格式无效`,
        topic_required: `请选择主题。`,
        message_required: `请填写留言`,
        send_message: `发送消息`,
        submit_success: `您的咨询已提交，OTCPro 团队将尽快回复您。`,
        footer_note: `身份验证通常在 1 个工作日内完成。合规相关咨询和审核可能需要额外处理时间。在银行营业时间外提交的存取款可能因银行和支付网络原因需要更长时间处理。OTCPro 交易服务 24/7 可用。`,
        topics: {
            trade_issue: `交易问题`,
            deposit_withdrawal: `充值 / 提现`,
            kyc_verification: `KYC / 验证帮助`,
            account_security: `账户安全`,
            other_inquiry: `其他咨询`,
        },
        attach_files: `附件（可选）`,
        drag_drop: `拖放图片或文档到此处`,
        browse_hint: `（PNG、JPG、PDF）或点击浏览`,
        max_size: `总计最大 10MB`,
        file_size_exceeded: `文件总大小不能超过 10MB。`,
        invalid_file_type: `文件类型无效，请仅上传 PNG、JPG 或 PDF 文件。`,
        upload_failed: `文件上传失败，请重试。`,
    },
    privacy: {
        h1: `隐私政策`,
        p1: `Rhino Trading Pty Ltd ACN 655 361 345 以OTCPro的商业名称（我们或我们）已在AUSTRAC注册，以提供DCE（数字货币交易所）服务。按法律要求，我们采取措施预防欺诈、洗钱和资助恐怖主义。我们承诺根据1988年《隐私法》Cth保护您的隐私。该法律规定了我们可能收集、使用和披露任何个人的个人信息的方式。`,
        h2: `我们收集哪些信息？`,
        p2: `我们从客户那里收集个人信息，用于身份验证。这可能包括一系列的信息，例如`,
        list1: {
            l1: `关于您的信息：您的姓名、地址、出生日期、联系方式、工作详情、照片识别、账单、`,
            l2: `关于您的财务和交易的信息：银行详情、帐户号码、数字货币帐户、交易行为特征和偏好、资金来源、交易目的`,
            l3: `关于您的浏览器和设备的信息，包括IP地址、浏览器供应商、设备类型和大小、cookie标识符`,
        },
        p3: `如果您是一个法人实体而不是个人，我们可能会收集以下信息，包括但不限于：`,
        list2: {
            l1: `注册和组建文件、`,
            l2: `公司声明证明注册办公室、所有权结构和董事、`,
            l3: `授权信授权用户负责账户、`,
            l4: `如果在监管下提供服务的资质、`,
            l5: `其他符合所有相关法律和法规的信息。`,
        },
        h3: `OTCPro是否共享您的个人信息？`,
        p4: `我们不出售、交易您的信息给他人。我们可能会向第三方供应商和服务提供商、监管机构、政府机关、执法机构和法院披露您的信息。我们可能会在法律要求或在《隐私法》允许的某些不寻常的其他情况下向他人提供您的信息。但是，我们会采取所有合理的步骤确保他们以我们相同的方式保护您的信息。`,
        h4: `我们如何保护您的信息？`,
        p5: `我们认识到确保客户个人信息的重要性。所有这些数据都将在一个隔离的私有网络中分配，我们通过使用加密协议和软件在传输过程中保护您的个人信息的安全。`,
        h5: `访问您的信息`,
        p6: `您可以根据要求获得您的个人信息的副本。您还可以通过登录到您的OTCPro帐户在我们的平台上管理、编辑或更新某些个人信息。我们还会纠正、修改或删除任何我们同意是不准确的、不相关的、过时的或不完整的个人信息。`,
        h6: `政策的修订`,
        p7: `我们可能会不时修改此隐私政策。请定期检查我们的网站以获取隐私政策的最新版本。`,
        p8: `对我们的政策有什么想法吗？`,
        p9: `如果您对我们的隐私政策有任何疑问、担忧或投诉，请从支持页面提交请求或发送邮件至 support{'@'}otcpro.io`
    },
    sign_in: {
        title: `登录`,
        btn_forgot: `忘记密码？`,
        btn_sign_up: `注册新账户`,
        btn_login: `登录`,
        email: '电子邮件地址',
        password: `密码`,
        msg_2fa: `您将会收到一份带有验证码的电子邮件，请前往查收。`,
        zp_loading: `认证中...`,
        zp_auth_failed: `认证请求失败，请确保在 Zapry 应用内打开后重试。`,
        zp_cancelled: `已取消`,
    },
    email_verify: {
        title: `邮箱验证`,
        label_email: `邮箱`,
        label_code: `验证码`,
        placeholder_email: `请输入邮箱`,
        placeholder_code: `请输入验证码`,
        btn_confirm: `确定`,
        btn_send_code: `重发验证码`,
        resend_in: `{n}s 后重发`,
        hint_invalid_email: `请输入有效的邮箱地址`,
        err_enter_email_first: `请先输入邮箱`,
        err_enter_email: `请输入邮箱`,
        err_enter_code: `请输入验证码`,
        success_sent: `验证码已发送至您的邮箱`,
        success_verified: `邮箱验证成功`,
        err_send_failed: `发送失败，请稍后重试`,
        err_verify_failed: `验证失败，请重试`,
    },
    deposit: {
        quick_recharge: {
            title: `快捷钱包充值`,
            ok_text: `确认充值`,
            cancel_text: `取消`,
            label_amount: `充值金额`,
            placeholder_amount: `请输入充值金额`,
            min_amount: `最小充值金额`,
            wallet_balance: `钱包余额`,
            refresh: `刷新`,
            label_remark: `备注（选填）`,
            placeholder_remark: `可选，便于您区分记录`,
            loading_connect: `正在连接钱包并获取余额…`,
            loading_balance: `正在获取余额…`,
            err_no_wallet: `请安装 MetaMask 或支持 WalletConnect 的钱包后重试`,
            err_no_account: `未获取到钱包账户，请授权连接`,
            err_connect_failed: `连接钱包或获取余额失败`,
            err_chain_not_configured: `链信息未配置`,
            err_invalid_amount: `请输入有效的充值金额`,
            err_below_min: `充值金额不能小于最小充值金额 {min} {asset}`,
            err_exceeds_balance: `充值金额不能大于钱包余额`,
            success_submitted: `充值已提交，到账请以链上确认为准`,
            err_tx_failed: `交易失败，请重试`,
            btn: `快捷钱包充值`,
        },
        crypto_detail: {
            min_deposit: {
                label: `最低充值：`,
                middle: `低于`,
                after: `的充值将不会入账。`,
            },
            tip: {
                title: `加快未来加密货币交易 🚀`,
                description_before: `在 `,
                description_highlight: `提现 → 管理加密货币地址`,
                description_after: ` 下添加您的自托管钱包地址。验证后，涉及这些地址的未来充值和提现通常可以更快处理。这是澳大利亚新监管要求的一部分，要求我们收集新添加钱包地址的来源钱包信息。`,
                manage_addresses: `管理地址`,
            },
            receiving_network: `接收网络`,
            destination_wallet_address: `目标钱包地址`,
        },
        details_flow: {
            banner: {
                title: `完善您的充值信息`,
                description: `您的充值因需要补充更多信息而待处理，请提供发送方资料以确保及时处理。`,
                highlight: `这只需要一分钟。`,
                cta: `立即完善`,
            },
            common: {
                close: `关闭`,
                back: `返回`,
                submit: `提交`,
                review_confirm: `审核并确认`,
                copy_success: `充值地址已复制`,
                copy_failed: `复制失败，请手动复制`,
                deposit_count: `此钱包有 {count} 笔充值`,
                items_count: `{count} 笔`,
                enter_value: `请输入 {value}`,
                options: {
                    other: `其他`,
                    others: `其他`,
                    low_risk_countries: `低风险名单中的国家`,
                    family_member: `家庭成员`,
                    friend: `朋友`,
                    business_partner: `商业伙伴`,
                    client_customer: `客户`,
                    client_customer_spaced: `客户`,
                    personal_transfer: `个人转账（赠与、支持）`,
                    payment_for_goods_or_services: `商品或服务付款`,
                    loan_or_repayment: `借款或还款`,
                    business_transaction: `商业交易`,
                    employer: `雇主`,
                    company_i_own_or_control: `我拥有或控制的公司`,
                    service_provider: `服务提供商`,
                    salary_income: `工资 / 收入`,
                    investment_funding: `投资 / 注资`,
                },
            },
            action_modal: {
                title: `需要补充更多信息`,
                description: `根据最新监管要求，我们需要您补充一些充值信息。`,
                summary: `有 {count} 个地址需要您处理`,
                deposit_count: `{count} 笔充值`,
                received_on: `接收时间 {timestamp}`,
                review_cta: `立即完善`,
            },
            review_modal: {
                title: `完善充值信息`,
                description: `请提供这笔充值的发送方信息。`,
                deposit_source_address: `充值来源地址`,
                deposit_transactions_count: `{count} 笔充值交易`,
                sender_type: {
                    title: `谁发送了这笔加密货币？`,
                    myself: `我自己（自托管钱包 / VASP）`,
                    others: `其他`,
                },
                account_owner: {
                    title: `发送这些资金的账户归谁所有？`,
                    subtitle: `即发送钱包或账户所归属的个人或机构。`,
                    individual: {
                        label: `个人`,
                        help: `向您转账的个人`,
                    },
                    business: {
                        label: `企业 / 公司`,
                        help: `公司或机构`,
                    },
                },
                individual: {
                    sender_name: {
                        label: `发送方姓名`,
                        placeholder: `请输入完整姓名...`,
                    },
                    person_base: {
                        label: `该个人所在地区`,
                        placeholder: `请选择该个人所在地区`,
                        other_placeholder: `请输入所在地区`,
                    },
                    relationship: {
                        label: `您与账户所有者的关系`,
                        placeholder: `请选择您的关系`,
                        other_placeholder: `请输入关系`,
                    },
                    transfer_purpose: {
                        placeholder: `请选择转账用途`,
                    },
                },
                business: {
                    company_name: {
                        label: `公司名称`,
                        placeholder: `请输入完整名称...`,
                    },
                    country: {
                        label: `公司所在国家`,
                        placeholder: `请选择公司所在国家`,
                        other_placeholder: `请输入公司所在国家`,
                    },
                    relationship: {
                        label: `您与该实体的关系`,
                        placeholder: `请选择您与该实体的关系`,
                        other_placeholder: `请输入您与该实体的关系`,
                    },
                    transfer_purpose: {
                        placeholder: `请选择本次转账用途`,
                    },
                },
                transfer_purpose: {
                    label: `本次转账的用途是什么？`,
                    help: `请选择本次转账的主要原因`,
                    other_placeholder: `请输入转账用途`,
                },
                wallet_type: {
                    title: `该地址来自您的私人钱包，还是来自 VASP？`,
                    self_hosted: {
                        label: `自托管钱包`,
                        help: `由您自己控制私钥的钱包（例如 MetaMask、Ledger）`,
                    },
                    vasp: {
                        label: `虚拟资产服务提供商`,
                        help: `以您本人名义注册的交易所账户（例如 Binance、Coinbase）`,
                    },
                },
                wallet_application_name: {
                    label: `钱包应用名称`,
                    placeholder: `钱包应用名称`,
                },
                vasp: {
                    platform_name: {
                        label: `平台名称`,
                        placeholder: `请选择平台`,
                        other_placeholder: `请输入平台名称`,
                    },
                    exchange_location: {
                        label: `该交易所位于哪里`,
                        placeholder: `请选择交易所所在地`,
                        other_placeholder: `请输入交易所所在地`,
                    },
                    account_identifier: {
                        label: `账户标识`,
                        placeholder: `请选择类型`,
                        value_placeholder: `请输入账户标识`,
                    },
                },
                    confirm_checkbox: `我确认该钱包地址由我拥有并控制`,
                    confirm_checkbox_help: `控制意味着只有您可以访问钱包的私钥或助记词。`,
            },
            submit_success: `地址 {address} 的充值信息已提交。`,
        },
    },
    sign_up: {
        title: `注册`,
        btn_login: `已经有账户了吗？点击登录`,
        email: '电子邮件地址',
        password: `密码`,
        password_repeat: `请重复密码`,
        referral_code: `推荐码 (可选)`,
        btn_submit: `提交注册`,
    },
    sign_up_success: {
        title: "欢迎使用 OTCPRO",
        sub_title: "感谢您加入 OTCPRO.",
        p1: "我们已向您注册的电子邮件地址发送了验证邮件",
        p2: "在您使用您注册的帐号登录之前，请务必根据邮件内的指示和链接激活您的帐号。",
        btn: "登录"
    },
    trade: {
        operation_completed: `操作完成`,
        operation_failed: `操作失败`,
    },
    withdraw: {
        form: {
            official_site: `官方网站：{domain}`,
            security_notice: `OTCPro 绝不会要求您缴纳保证金、验证费或预付款来解冻提现。若出现此类提示，请立即关闭页面，仅通过 {domain} 联系我们。`,
            tamper_alert_title: `安全警告`,
            tamper_alert_description: `下方提现说明可能被不可信来源（如浏览器插件）篡改。请勿转账。请使用无痕模式并禁用扩展后重试，或通过官网联系客服。`,
            tips: {
                aud: {
                    local_fee: `澳大利亚本地 AUD 提现超过 $10,000 免手续费，低于 $10,000 将收取 $3 小额转账费。`,
                    international_fee: `国际 AUD 提现收取 $50 转账费，将从您的提现金额中扣除。`,
                    bank_details: `银行信息填写错误将导致严重延误，被拒提现可能产生额外费用。`,
                },
                usd: {
                    transfer_fee: `转账费：50 USD，将从您的提现金额中扣除`,
                    small_withdrawal_fee: `低于 $50,000 的提现另收 100 USD 小额提现费（不含转账费）`,
                    bank_details: `银行信息填写错误将导致严重延误，被拒资金可能产生额外费用`,
                },
                token: {
                    wrong_network: `发送至错误网络或地址的加密货币无法找回。`,
                    own_wallet: `请绑定您本人控制的钱包地址用于加密货币结算。`,
                },
            },
        },
        email_verify: {
            description: `请输入发送到您邮箱的 6 位验证码。`,
            get_code: `获取验证码`,
            resend_code: `重新发送验证码`,
        },
        two_fa_verify: {
            description: `请输入身份验证器 App 中的 6 位验证码。`,
        },
        token_address_book: {
            entry: {
                title: `管理加密货币地址`,
                description: `添加并查看您用于加密货币提现的钱包地址。`,
                button_title: `新增地址`,
                button_subtitle: `创建新的提现地址`,
            },
            list: {
                title: `地址列表`,
                columns: {
                    token: `币种`,
                    chain: `链`,
                    memo: `MEMO`,
                    address: `地址`,
                    nickname: `昵称`,
                    status: `状态`,
                },
                confirm: {
                    title: `您确定要删除这个地址吗？`,
                    description: `此操作无法撤销，您之后需要手动重新添加该地址。`,
                    ok: `是`,
                    cancel: `否`,
                },
                delete: `删除`,
                deleted: `加密货币地址已删除。`,
                copy_address: `复制地址`,
                copy_success: `地址已复制。`,
                copy_failed: `无法复制地址。`,
                status_verified_note: `该地址已成功验证，可用于提现。`,
            },
            modal: {
                title: `新增地址`,
                description: `请输入您要用于加密货币提现的钱包信息。`,
            },
            modal_unavailable: {
                title: `地址不可用`,
                description: `该地址无法添加，请输入其他钱包地址。`,
            },
            form: {
                title: `新增加密货币地址`,
                description: `请输入您要用于加密货币提现的钱包信息。`,
                token: `币种`,
                token_placeholder: `选择币种`,
                network: `网络`,
                network_placeholder: `选择网络`,
                address: `地址`,
                address_placeholder: `输入钱包地址...`,
                address_tip_title: `请确保该钱包地址属于您本人。`,
                address_tip_description: `我们仅支持提现至您本人控制的钱包地址。`,
                destination_tag: `Memo（Destination Tag）`,
                destination_tag_placeholder: `请输入 Destination Tag`,
                nickname: `昵称`,
                nickname_placeholder: `为这个钱包填写昵称...`,
                token_address: `地址`,
                success_title: `加密货币地址已成功添加`,
                success_description: `多行提示内容展示，支持更长的正文内容，多行提示内容展示，支持更长的正文内容`,
                unavailable_title: `该地址已关联到其他账户`,
                unavailable_description: `出于安全与合规要求，每个地址仅可关联一个账户，且必须属于用户本人。若您确认该地址属于您，请联系支持团队。`,
                warning: `请仅添加您本人拥有的钱包地址用于接收加密货币提现`,
            },
            common: {
                close: `关闭`,
            },
            confirm_modal: {
                step: `第 2 步，共 3 步`,
                title: `完善您的钱包地址信息`,
                destination_wallet_address: `目标钱包地址`,
                copy_address: `复制地址`,
                copy_success: `地址已复制。`,
                copy_failed: `无法复制地址。`,
                own_wallet_question: `这是您自己的钱包地址吗？`,
                own_wallet_yes: `是，我正在转入我自己的钱包地址`,
                own_wallet_no: `否，这个钱包或账户属于其他个人或实体`,
                wallet_type_question: `这个地址来自您的私人钱包，还是来自 VASP？`,
                wallet_type_self_hosted: `自托管钱包`,
                wallet_type_self_hosted_description: `由您自行掌握私钥的个人钱包（例如 MetaMask、Ledger）`,
                wallet_type_vasp: `虚拟资产服务提供商`,
                wallet_type_vasp_description: `注册在您名下的交易所账户（例如 Binance、Coinbase）`,
                ownership_confirmation: `我确认该钱包地址由我拥有并控制`,
                continue: `继续`,
            },
            tr_modal: {
                step: `第 2 步，共 3 步`,
                title: `完善您的钱包地址信息`,
                destination_wallet_address: `目标钱包地址`,
                copy_address: `复制地址`,
                copy_success: `地址已复制。`,
                copy_failed: `无法复制地址。`,
                own_wallet_question: `这是您自己的钱包地址吗？`,
                own_wallet_yes: `是，我正在转入我自己的钱包地址`,
                own_wallet_no: `否，这个钱包地址属于其他个人或实体`,
                wallet_type_question: `这个地址来自您的私人钱包，还是来自 VASP？`,
                wallet_type_self_hosted: `自托管钱包`,
                wallet_type_self_hosted_description: `由您自行掌握私钥的个人钱包（例如 MetaMask、Ledger）`,
                wallet_type_vasp: `虚拟资产服务提供商`,
                wallet_type_vasp_description: `注册在您名下的交易所账户（例如 Binance、Coinbase）`,
                wallet_application_name: {
                    label: `钱包应用名称`,
                    placeholder: `钱包应用名称`,
                },
                self_hosted_truthfulness_notice_before: `请独立、如实地提供信息。如果您正在按照他人的指示提供虚假信息，您可能正在遭遇`,
                self_hosted_truthfulness_notice_emphasis: `诈骗！`,
                self_hosted_truthfulness_notice_after: ``,
                wallet_application_screenshot: {
                    label: `钱包应用截图`,
                    description: `请上传您本人手机上的钱包应用截图，包括钱包界面或您访问钱包时使用的网站地址。`,
                },
                wallet_address_screenshot: {
                    label: `钱包地址截图`,
                    description: `请清晰展示完整的钱包地址，并确保地址可读。请勿包含助记词或私钥。`,
                },
                screenshot_upload: {
                    title: `上传截图`,
                    uploading: `上传中...`,
                    replace: `替换截图`,
                    remove: `删除`,
                    invalid_type: `请上传 PNG 或 JPG 图片。`,
                    file_too_large: `截图大小不能超过 10MB。`,
                    failed: `截图上传失败，请重试。`,
                },
                screenshot_truthfulness_notice: `两张截图都必须由您本人直接使用自己的设备拍摄。请勿使用他人提供或发送的截图。`,
                ownership_confirmation: `我确认该钱包地址由我拥有并控制`,
                ownership_confirmation_help: `控制意味着只有您可以访问钱包的私钥或助记词。`,
                not_supported_title: `该钱包暂不支持`,
                not_supported_description: `出于安全与合规要求，提现只能发送到登记在您本人名下的钱包或账户。如果该钱包地址不属于您本人名下，您的提现请求将被自动取消。`,
                continue: `继续`,
                vasp: {
                    exchange_platform_based: {
                        label: `该交易平台注册在哪个国家/地区？`,
                        subtitle: `这里指的是交易平台所在国家/地区，而不是您的个人所在地`,
                        placeholder: `选择平台所在国家/地区...`,
                        other_placeholder: `请输入平台所在国家/地区...`,
                    },
                },
            },
            high_risk_modal: {
                title: `地址无法使用`,
                description: `该钱包地址未通过我们的安全与合规检查。\n为保障您的资产安全，请使用由您本人拥有并控制的钱包地址。`,
            },
            already_bound_modal: {
                title: `该地址已关联到其他账户`,
                description: `出于安全与合规要求，每个地址仅可关联一个账户，且必须属于用户本人。若您确认该地址属于您，请联系支持团队。`,
                
            },
            address_unavailable_modal: {
                title: `地址不可用`,
                line1_before: `该钱包地址被判定为 `,
                line1_highlight: `高风险`,
                line1_after: `，无法用于提现。`,
                line2: `为保护您的账户并满足监管要求，请移除此地址，并改用您本人控制的其他钱包地址。`,
            },
            generic_error_modal: {
                title: `地址无法使用`,
                description: `该钱包地址当前无法使用。`,
            },
            error_modal: {
                action: `尝试其他地址`,
            },
            security_modal: {
                title: `安全验证`,
                authenticator_code: `身份验证器验证码`,
                authenticator_hint: `请输入身份验证器应用中的 6 位验证码`,
                password: `账户密码`,
                email_code: `邮箱验证码`,
                resend: `发送邮箱验证码`,
                resend_short: `发送验证码`,
                resend_in: `{n}s 后重发`,
                send_success: `验证码已发送到您的邮箱。`,
                send_failed: `请求过于频繁，请稍后再试。`,
                submit: `提交`,
                next: `下一步`,
                verify_failed: `验证码无效。`,
                save_success: `加密货币地址已创建。`,
            },
        },
        detail: {
            whats_next_title: `下一步？`,
            whats_next_pending_p1: `您的提款申请目前正在审核中。`,
            whats_next_pending_p2: `为尽量减少处理延迟，建议在澳洲东部时间上午 9 点至晚上 9 点之间进行存取款。不同金融机构的处理时间可能有所不同。`,
            whats_next_pending_p3: `如需取消，请尽快联系我们的客服团队并提供相关参考编号。提款一旦完成，将无法撤销。`,
            transaction_notice_title: `交易须知`,
            transaction_notice_p1: `此交易由平台创建。可能与服务费调整、多付款项或根据适用平台政策对您账户交易的更正相关。无需采取进一步行动。`,
            transaction_notice_p2: `如需查询此交易，请联系我们的客服团队并提供相关参考编号。`,
            withdraw_to_title: `提款至`,
            nick_name: `昵称`,
            token_label: `代币`,
            chain_label: `链`,
            address_label: `地址`,
            bank_name_label: `银行名称`,
            bsb_label: `BSB`,
            account_number_label: `账号`,
            account_name_label: `账户名`,
        },
    },
    kyc: {
        btn_update_now: "立即更新",
        individual_email_title: "个人邮箱地址",
        individual_email_hint: "此邮箱用于完成身份验证（包括人脸验证），并确保该个人知晓公司账户注册事宜",
        financial_statements_title: "财务报表",
        financial_statements_desc: "最近一个财年的财务报表，包括资产负债表、损益表和现金流量表（如有）"
    }
}
